














import { isEqual } from "lodash-es";
import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import {
  ContentFeed,
  ContentFeedSearchResult,
  InputDiscoveryContentFeedSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import WithContentFeed from "@/mixins/WithContentFeed";
import { getPurchasedContentFeeds } from "@/lib/contentFeedHelper";
import { Throttle } from "@/lib/decorators";
import emitter from "@/lib/emitter";
import { feedFields } from "@/helpers";
import { EVENTS } from "@/const";
import DiscoverView from "./components/DiscoverView.vue";

@Component({ name: "PageDiscover", components: { DiscoverView } })
export default class PageDiscover extends mixins(WithContentFeed, WithAuthUser) {
  @Prop({ type: Boolean, default: false })
  public readonly onFeed!: boolean;

  public loading: boolean = false;

  public enableScroll: boolean = false;

  public contentFeedSearchResult: ContentFeedSearchResult | null = null;

  public followedUsersId: Record<string, boolean> = {};

  public filterData!: InputDiscoveryContentFeedSearch;

  public generateRandomSeed() {
    return Math.round(Math.random() * 999999) + 1;
  }

  public handleFollow(userId: string, followStatus: boolean) {
    this.$set(this.followedUsersId, userId, followStatus);
  }

  public onContentFeedUpdate(contentFeed: ContentFeed) {
    if (this.contentFeedSearchResult?.result) {
      this.$set(
        this.contentFeedSearchResult,
        "result",
        this.contentFeedSearchResult.result.map(i => (i.id === contentFeed.id ? contentFeed : i))
      );
    }
  }

  @Throttle(100, { leading: false })
  public async getDiscovery(data: InputDiscoveryContentFeedSearch, replace: boolean = true, feedIdToFind?: string) {
    try {
      this.enableScroll = false;
      let response = await this.contentFeedDiscoverySearch(data, feedIdToFind, feedFields());
      if (replace) {
        this.contentFeedSearchResult = response;
      } else {
        this.contentFeedSearchResult = {
          ...response,
          result: [...(this.contentFeedSearchResult ? this.contentFeedSearchResult.result : []), ...response.result],
        };
      }
    } finally {
      this.enableScroll = this.contentFeedSearchResult?.hasNextPage ?? false;
    }
  }

  public async scrollHandler(cb?: Function) {
    try {
      if (this.contentFeedSearchResult && this.contentFeedSearchResult.hasNextPage) {
        await this.getDiscovery({ ...this.filterData, page: this.contentFeedSearchResult.page + 1 }, false);
      }
    } finally {
      cb && cb();
    }
  }

  public async updateFeed(payload: { userId: string; feedId?: string }) {
    if (!this.contentFeedSearchResult) {
      return;
    }
    try {
      this.$set(
        this.contentFeedSearchResult,
        "result",
        await getPurchasedContentFeeds(
          { authorId: payload.userId, purchasedFeedId: payload.feedId },
          this.contentFeedSearchResult,
          undefined,
          feedFields()
        )
      );
    } finally {
      if (!payload.feedId) {
        this.handleFollow(payload.userId, true);
      }
    }
  }

  public onFilter(filterData: Partial<InputDiscoveryContentFeedSearch>) {
    if (!isEqual(this.filterData, { ...filterData, randomSeed: this.filterData.randomSeed })) {
      this.filterData = { ...filterData, randomSeed: this.generateRandomSeed() };
      this.loadDiscovery();
    }
  }

  @Watch("authUser")
  public loadDiscoveryOnlyForLogin(user: User | null, oldUser: User | null) {
    if (!oldUser && user && user.accountInfo.lastLoginTime && this.authAllowAccess) {
      this.loadDiscovery().then(() => window.scrollTo({ top: 0 }));
    }
  }

  public async loadDiscovery() {
    try {
      this.loading = true;
      await this.getDiscovery(this.filterData);
    } finally {
      this.loading = false;
    }
  }

  public created() {
    this.filterData = { randomSeed: this.generateRandomSeed() };
    this.loadDiscovery();
    emitter.on<any>(EVENTS.CONTENT_FEED_PURCHASED, this.updateFeed);
  }

  public async destroyed() {
    emitter.off<any>(EVENTS.CONTENT_FEED_PURCHASED, this.updateFeed);
  }
}
